import ProjectUserFull from "./project-user-full";
import Collection from "../../data-structures/collection";

export default class ProjectUsersFullCollection extends Collection<ProjectUserFull> {

    constructor(models:ProjectUserFull[]=[]) {
        super(models)
    }

    static initFromJson(data:JSONArray):ProjectUsersFullCollection {

        // @ts-ignore
        const models : ProjectUserFull[] = _.map(data, (modelData:JSONObject) =>{
            return new ProjectUserFull(modelData)
        })

        const collection = new ProjectUsersFullCollection(models)
        return collection
    }

    findFullAccessUsers():ProjectUsersFullCollection {
        return new ProjectUsersFullCollection(_.filter(this.models, m=>m.isUser && m.access === gd.const.project.access.FULL))
    }

    get projectUsersCollection() {
        const models = _.filter(this.models, (projectUser: ProjectUserFull) => {
            return projectUser.isUser
        })
        return new ProjectUsersFullCollection(models)
    }

    get projectTeamsCollection() {
        const models = _.filter(this.models, (projectUser: ProjectUserFull) => {
            return projectUser.isTeam
        })
        return new ProjectUsersFullCollection(models)
    }
}